import { priceFormat } from "@/utils";

export default ({ app, $axios, store }, inject) => {
  const currencySymbol = store.state?.general?.settings?.currency_sign || "";

  // Inject $priceFormat
  inject("priceFormat", (number) => priceFormat(number, currencySymbol));
};
